// extracted by mini-css-extract-plugin
export default {"header__button--wrapper":"header__button--wrapper_xhCcgwzv","header__button--content":"header__button--content_yXw5XQGM","header__button--divider":"header__button--divider_ZMecfGtf"};